import { $t } from '@teachino/shared-i18n';
import {
  type InfrastructureCommand,
  InfrastructureCommandBuilder,
} from '@teachino/shared-infrastructure';
import { useGlobalDependencyProvider } from '@teachino/shared-util';
import { useMutation } from '@urql/vue';
import { createCourseMaterialMutation } from './create-course-material.mutation';
import type { CourseMaterialsFacade } from './course-materials.facade';

export class CourseMaterialsService implements CourseMaterialsFacade {
  private globalDi = useGlobalDependencyProvider();
  private analytics = this.globalDi.inject('analytics');
  private user = this.globalDi.inject('user');

  private _createMaterial = useMutation(createCourseMaterialMutation);

  createCourseMaterial(args: {
    courseFolderId?: string;
    courseId: string;
    name?: string;
    contentHtml?: string;
    initialIpiRequestId?: string | null;
  }): InfrastructureCommand<{ id: string }> {
    const newEditor = this.user.materialEditorMode.value === 'new';
    const defaultName = $t('material.default_name');
    const { courseFolderId, courseId, name, contentHtml, initialIpiRequestId } =
      args;
    return InfrastructureCommandBuilder.fromMutation(this._createMaterial, {
      icon: ':memo:',
      courseFolderId,
      courseId,
      contentHtml,
      name: name ?? defaultName,
      initialIpiRequestId,
      newEditor,
    })
      .withMapper((result) => {
        return { id: result.createCourseMaterial.courseMaterial.material.id };
      })
      .build();
  }
}
